export const DataWhy = [
    {
        id:1,
        numbers:"24/7",
        title:"Delivery & Caesarean",
    },
    {
        id:2,
        numbers:"12 +",
        title:"Years of Experience",
    },
    {
        id:3,
        numbers:"6000 +",
        title:"Baby Deliveries",
    },
    {
        id:4,
        numbers:"10,000 +",
        title:"Happy patients",
    },

];
